// Module
var code = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 14.5L11.5 10L10 11.5L14.5 16L10 20.5L11.5 22L16 17.5L20.5 22L22 20.5L17.5 16L22 11.5L20.5 10L16 14.5Z\" fill=\"#999999\"/> </svg> ";
// Exports
module.exports = code;